module.exports = __webpack_public_path__ + "static/media/check.a4227e82.svg";